import theme from "@/styles/theme";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {grey} from "@mui/material/colors";
import { ContentContainer } from "@/components/ContentContainer";
import { PartnerEntry } from "@/components/partner/PartnerEntry";
import PageHead from "@/components/PageHead";

export default function Partner({page}) {

  return (
      <>
        <PageHead page={page} />
        <ContentContainer headline={page?.headline} image={page?.backgroundimage?.formats?.large?.url}>
          <Typography
            variant="body2"
            sx={{
              mb: 3,
              [theme.breakpoints.up("sm")]: {
                mb: 6,
              },
            }}
          >
            {page.introduction}
          </Typography>
          <Grid
            container
            spacing={3}
            sx={{
              "& > .MuiGrid-root": {
                paddingBottom: "1.5rem",
                "&:not(:last-of-type)": {
                  position: "relative",
                  "&::after": {
                    position: "absolute",
                    content: "''",
                    borderBottomColor: grey[500],
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1px",
                    width: "calc(100% - 1.5rem)",
                    transform: "translateY(1.5rem)",
                  },
                },
              },
            }}
          >
            {page.Partner.map((p, i) => {
              return (
                <Grid item xs={12} key={i}>
                  <PartnerEntry partner={p} />
                </Grid>
              );
            })}
          </Grid>
        </ContentContainer>
      </>
  );
}

export const getStaticProps = async() => {
    const pageResponse = await fetch(`${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}/partner`);
    const page = await pageResponse.json();

    return {
        props: {
            page
        },
        revalidate: parseInt(process.env.SSG_REVALIDATE_TIMEOUT)
    }
}